/**
 * Exportação em CSV.
 *
 * Separador `;` e decimal com vírgula: é o que o Excel em português abre com um duplo
 * clique, sem assistente de importação. O BOM na frente existe pela mesma razão — sem
 * ele, "Fundação" chega como "FundaÃ§Ã£o" na planilha de quem recebe.
 *
 * O arquivo sai do que **está na tela**: mesmo período, mesmo recorte. Um CSV que
 * exportasse outro intervalo produziria dois números para a mesma pergunta.
 */

/** BOM UTF-8, escrito por escape para não virar caractere invisível no código-fonte. */
const BOM = '\uFEFF';

function escapeCell(value: string | number): string {
  const text = typeof value === 'number' ? formatNumber(value) : value;
  return /[";\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** Decimal brasileiro — o Excel em pt-BR lê `4,5` como número e `4.5` como texto. */
export function formatNumber(value: number): string {
  return Number.isInteger(value) ? String(value) : value.toFixed(2).replace('.', ',');
}

export function toCsv(
  headers: readonly string[],
  rows: readonly (readonly (string | number)[])[],
): string {
  const lines = [headers.map(escapeCell).join(';')];
  for (const row of rows) lines.push(row.map(escapeCell).join(';'));
  return `${BOM}${lines.join('\r\n')}\r\n`;
}

/** Entrega o arquivo ao navegador e revoga a URL temporária logo em seguida. */
export function downloadCsv(fileName: string, content: string): void {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName.endsWith('.csv') ? fileName : `${fileName}.csv`;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
